import React from 'react';
import { BrainIcon, LineChartIcon, ShieldCheckIcon, RefreshCwIcon, ZapIcon, LayersIcon } from 'lucide-react';
const FeatureItem = ({
  icon,
  title,
  description
}) => {
  return <div className="flex gap-4" data-id="element-103">
      <div className="flex-shrink-0 mt-1" data-id="element-104">
        <div className="w-10 h-10 bg-indigo-600 rounded-full flex items-center justify-center text-white shadow-md" data-id="element-105">
          {icon}
        </div>
      </div>
      <div data-id="element-106">
        <h3 className="text-lg font-medium text-gray-900" data-id="element-107">{title}</h3>
        <p className="mt-1 text-gray-700" data-id="element-108">{description}</p>
      </div>
    </div>;
};
export const FeaturesSection = () => {
  const features = [{
    icon: <BrainIcon size={20} data-id="element-109" />,
    title: 'Advanced Machine Learning',
    description: 'Our platform utilizes cutting-edge machine learning algorithms to continuously improve and adapt to your business needs.'
  }, {
    icon: <LineChartIcon size={20} data-id="element-110" />,
    title: 'Predictive Analytics',
    description: 'Leverage the power of predictive analytics to anticipate market trends and make data-driven decisions.'
  }, {
    icon: <ShieldCheckIcon size={20} data-id="element-111" />,
    title: 'Enterprise-Grade Security',
    description: 'Rest easy knowing your data is protected with state-of-the-art security protocols and compliance measures.'
  }, {
    icon: <RefreshCwIcon size={20} data-id="element-112" />,
    title: 'Seamless Integration',
    description: 'Easily connect with your existing enterprise systems and third-party applications through our flexible API.'
  }, {
    icon: <ZapIcon size={20} data-id="element-113" />,
    title: 'Real-Time Insights',
    description: 'Access real-time data and insights across all departments to make informed decisions faster.'
  }, {
    icon: <LayersIcon size={20} data-id="element-114" />,
    title: 'Scalable Architecture',
    description: 'Our cloud-based platform scales with your business, ensuring optimal performance regardless of company size.'
  }];
  return <section id="features" className="w-full py-16 bg-white border-b border-gray-200" data-id="element-115">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-116">
        <div className="text-center mb-12" data-id="element-117">
          <h2 className="text-3xl font-bold text-gray-900" data-id="element-118">
            Powerful AI Features
          </h2>
          <p className="mt-4 text-xl text-gray-700 max-w-3xl mx-auto" data-id="element-119">
            Our comprehensive suite of AI-powered tools transforms how
            enterprises operate, driving efficiency and innovation.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-10" data-id="element-120">
          {features.map((feature, index) => <FeatureItem key={index} icon={feature.icon} title={feature.title} description={feature.description} data-id="element-121" />)}
        </div>
      </div>
    </section>;
};